import { render, staticRenderFns } from "./StreamRegionPC.vue?vue&type=template&id=d747c83c&scoped=true"
import script from "./StreamRegionPC.vue?vue&type=script&setup=true&lang=ts"
export * from "./StreamRegionPC.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StreamRegionPC.vue?vue&type=style&index=0&id=d747c83c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d747c83c",
  null
  
)

export default component.exports